module.exports = __webpack_public_path__ + "img/next.c0cc6856.svg";